import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import { varContainer } from './variants';

// ----------------------------------------------------------------------

export function MotionViewport(t0) {
  const $ = _c(12);
  let children;
  let disableAnimate;
  let other;
  let viewport;
  if ($[0] !== t0) {
    ({
      children,
      viewport,
      disableAnimate,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disableAnimate;
    $[3] = other;
    $[4] = viewport;
  } else {
    children = $[1];
    disableAnimate = $[2];
    other = $[3];
    viewport = $[4];
  }
  let t1;
  if ($[5] !== disableAnimate || $[6] !== viewport) {
    t1 = disableAnimate ? {} : {
      component: m.div,
      initial: "initial",
      whileInView: "animate",
      variants: varContainer(),
      viewport: {
        once: true,
        amount: 0.3,
        ...viewport
      }
    };
    $[5] = disableAnimate;
    $[6] = viewport;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const baseProps = t1;
  let t2;
  if ($[8] !== baseProps || $[9] !== children || $[10] !== other) {
    t2 = <Box {...baseProps} {...other}>{children}</Box>;
    $[8] = baseProps;
    $[9] = children;
    $[10] = other;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}